var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-template"},[_c('div',{staticClass:"menu-aux"}),_c('div',{staticClass:"menu-debits",style:(_vm.fundoMenuDebitsEstilizado)},[_c('menu-debits')],1),_c('div',{staticClass:"page-debit"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }